(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  document.querySelectorAll('[data-dismiss-announcement]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var bar = btn.closest('.announcement-bar');
      if (bar) {
        bar.style.display = 'none';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  var openBtn = document.querySelector('[data-open-mobile-menu]');
  var dialog = document.getElementById('mobile-menu');
  var closeBtn = document.querySelector('[data-close-mobile-menu]');

  if (openBtn && dialog) {
    openBtn.addEventListener('click', function() {
      dialog.showModal();
    });
  }

  if (closeBtn && dialog) {
    closeBtn.addEventListener('click', function() {
      dialog.close();
    });
  }

  if (dialog) {
    dialog.addEventListener('click', function(e) {
      if (e.target === dialog) {
        dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Thumbnail image gallery
  document.querySelectorAll('.product-page__thumbnail').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mainImg = document.getElementById('main-product-image');
      if (mainImg) {
        mainImg.src = thumb.dataset.imageUrl;
        mainImg.alt = thumb.dataset.imageAlt;
      }
      document.querySelectorAll('.product-page__thumbnail').forEach(function(t) {
        t.classList.remove('product-page__thumbnail--active');
      });
      thumb.classList.add('product-page__thumbnail--active');
    });
  });

  // Quantity +/- buttons
  var qtyInput = document.querySelector('.product-page__qty-input');
  var minusBtn = document.querySelector('[data-qty-minus]');
  var plusBtn = document.querySelector('[data-qty-plus]');

  if (minusBtn && qtyInput) {
    minusBtn.addEventListener('click', function() {
      var val = parseInt(qtyInput.value, 10);
      if (val > 1) qtyInput.value = val - 1;
    });
  }

  if (plusBtn && qtyInput) {
    plusBtn.addEventListener('click', function() {
      var val = parseInt(qtyInput.value, 10);
      qtyInput.value = val + 1;
    });
  }

  } catch(e) { console.error(e); }
})();
})();
